import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const NoSurveyBox = () => {
  const { navigation } = useNavigation()

  return (
    <Box background="viridian100" padding="s24" borderRadius={{ all: 'abs016' }} gap="s8">
      <Box flexDirection="row" gap="s4">
        <Icon.Medium icon="lightbulb" color="viridian1000" />
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('processes.process_settings.actions.survey_action.empty_surveys.title')}
        </Text.Normal>
      </Box>
      <Text.Normal color="grey1000">
        {i18n.t('processes.process_settings.actions.survey_action.empty_surveys.description')}
      </Text.Normal>
      <Box paddingTop="s8" flexDirection="row">
        <Button.Router to={navigation.processes.surveys.fullPath()} type="secondary">
          {i18n.t('processes.process_settings.actions.survey_action.empty_surveys.button')}
        </Button.Router>
      </Box>
    </Box>
  )
}
